import React, { useState } from "react";
import DashboardHeader from "../../layout/dashboard/DashboardHeader";
import Sidebar from "../../shared/components/Sidebar";
import { Button } from "primereact/button";
import { TabView, TabPanel } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import MasterImg from "../../assets/images/Master Splits.png";
import PublishingImg from "../../assets/images/Publishing Splits.png";
import DistributorImg from "../../assets/images/Distributor.png";
import { Link } from "react-router-dom";
import Footer from "../../layout/common/Footer";

export default function Agreement() {
  const [expanded, setExpanded] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleShowMoreClick = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      {/* <DashboardHeader /> */}
      <div className="dashboard flex">
        {/* <Sidebar /> */}
        <div className="px-4 py-3 xl:px-8 xl:py-6 mt-2 w-full">
          <div>
            <h2 className="capitalize mb-5 pb-1">Your Agreement Library</h2>
          </div>
          <div className="alarms karla border-round overflow-hidden">
            <div className="top-layer text-white img-cover flex align-items-center">
              <h3>Alarms</h3>
            </div>
            <div className="alarm-data">
              <div className="importent-notice inline-flex align-items-center capitalize color-grey font-bold text-base md:text-lg">
                <p>Importance</p>
                <p>Notice</p>
              </div>
              <div className="notice-list font-bold flex align-items-center text-base md:text-lg py-3 border-bottom-1">
                <div className="">
                  <span className="text-sm inline-flex align-items-center justify-content-center urgent-bg color-white border-round">
                    Urgent!
                  </span>
                </div>
                <div className="flex w-full align-items-center justify-content-between">
                  <p className="color-black">
                    Your licensing contract is expiring in 1 month
                  </p>
                  <Button
                    label="View"
                    link
                    onClick={() => window.open("https://react.dev", "_blank")}
                    className="p-0 color-verdigris underline text-base lg:text-lg text-right font-medium"
                  />
                </div>
              </div>
              <div className="notice-list font-bold flex align-items-center text-base md:text-lg py-3 border-bottom-1">
                <div className="">
                  <span className="text-sm inline-flex align-items-center justify-content-center urgent-bg color-white border-round">
                    Urgent!
                  </span>
                </div>
                <div className="flex w-full align-items-center justify-content-between">
                  <p className="color-black">
                    Your artist recording agreement is due to renew in 2 months
                  </p>
                  <Button
                    label="View"
                    link
                    onClick={() => window.open("https://react.dev", "_blank")}
                    className="p-0 color-verdigris underline text-base lg:text-lg text-right font-medium"
                  />
                </div>
              </div>
              <div className="notice-list font-bold flex align-items-center text-base md:text-lg py-3 border-bottom">
                <div className="">
                  <span className="text-sm inline-flex align-items-center justify-content-center priority-bg color-white border-round">
                    Priority!
                  </span>
                </div>
                <div className="flex w-full align-items-center justify-content-between">
                  <p className="color-black">
                    Your royalty statement is due in 3 months
                  </p>
                  <Button
                    label="View"
                    link
                    onClick={() => window.open("https://react.dev", "_blank")}
                    className="p-0 color-verdigris underline text-base lg:text-lg text-right font-medium"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 md:mt-6 pt-2 karla pb-2 flex justify-content-between flex-wrap">
            <div className="agreement-storage w-full text-base md:text-lg">
              <h3 className="mb-3">Agreement Storage</h3>
              <p className="opacity-50">All your agreements in one place.</p>
              <div className="border-2 border-round overflow-hidden project-tabs">
                <TabView>
                  <TabPanel
                    header="All Projects"
                    className="text-base md:text-lg color-verdigris font-bold"
                  >
                    <h3 className="color-black mb-3 md:mb-6">All Projects</h3>
                    <p>Writer split sheet</p>
                    <p>Side Artist Agreement & Term Sheet</p>
                    <p>Producer Agreement & Term Sheet</p>
                    <p>Artwork Agreement & Term Sheet</p>
                    <p>Music Video Agreement & Term Sheet</p>
                  </TabPanel>
                  <TabPanel
                    header="Forestry"
                    className="text-base md:text-lg color-verdigris font-bold"
                  >
                    <h3 className="color-black mb-3 md:mb-6">Forestry</h3>
                    <p>Forestry Writer split sheet</p>
                    <p>Forestry Side Artist Agreement & Term Sheet</p>
                    <p>Forestry Producer Agreement & Term Sheet</p>
                    <p>Forestry Artwork Agreement & Term Sheet</p>
                    <p>Forestry Music Video Agreement & Term Sheet</p>
                  </TabPanel>
                </TabView>
              </div>
            </div>
            <div
              className={`royality-summary w-full text-base md:text-lg relative ${
                expanded ? "expanded" : ""
              }`}
            >
              <h3 className="mb-3">Royalty Summary</h3>
              <p className="opacity-50">
                Pie charts on royalty splits for each single.
              </p>
              <div className="border-2 relative border-round overflow-hidden project-tabs">
                <Accordion
                  activeIndex={activeIndex}
                  onTabChange={(e) => setActiveIndex(e.index)}
                >
                  <AccordionTab
                    header="Forestry"
                    className="text-base md:text-lg color-verdigris font-bold"
                  >
                    <div className="flex gap-3 w-full flex-wrap">
                      <div className="w-5">
                        <p className="color-verdigris">Master Splits</p>
                        <img src={MasterImg} alt="Master Splits" />
                      </div>
                      <div className="w-5">
                        <p className="color-verdigris">Publishing Splits</p>
                        <img src={PublishingImg} alt="Master Splits" />
                      </div>
                      <div className="w-5">
                        <p className="color-verdigris">
                          illustrated raw data imported from
                          label/distributor/publisher
                        </p>
                        <img src={DistributorImg} alt="Master Splits" />
                      </div>
                    </div>
                  </AccordionTab>
                  <AccordionTab header="Forestry 2">
                    <div>
                      <p className="color-verdigris">Master Splits</p>
                      <img src={MasterImg} alt="Master Splits" />
                      <p className="color-verdigris">Publishing Splits</p>
                      <img src={PublishingImg} alt="Master Splits" />
                      <p className="color-verdigris">
                        illustrated raw data imported from
                        label/distributor/publisher
                      </p>
                      <img src={DistributorImg} alt="Master Splits" />
                    </div>
                  </AccordionTab>
                </Accordion>
                {activeIndex !== null ? (
                  <Link
                    to={""}
                    onClick={handleShowMoreClick}
                    className="hidden lg:block mt-3 show-more absolute left-50 underline font-bold"
                  >
                    {expanded ? "Show Less" : "Show More"}
                  </Link>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
}
